import styled from 'styled-components';

import { Text } from '@gympass/yoga';
import { wellzTheme } from '@wellz-theme/mui';

import { Button as YogaButton } from 'components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const WarningContainer = styled.div`
  flex-grow: 1;
  display: flex;
  max-width: 500px;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: ${({ theme }) => theme.yoga.spacing.medium}px;

  svg {
    width: ${wellzTheme.spacing(15)};
    height: ${wellzTheme.spacing(15)};
  }
`;

export const Title = styled(Text.H5)`
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const Subtitle = styled(Text.Small)`
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  color: ${({ theme }) => theme.yoga.colors.textSecondary};
`;

export const Button = styled(props => <YogaButton {...props} />)`
  width: 100%;
  max-width: 500px;
`;
